import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=c529ac12&scoped=true&"
import script from "./Keyword.vue?vue&type=script&lang=js&"
export * from "./Keyword.vue?vue&type=script&lang=js&"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=c529ac12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c529ac12",
  null
  
)

export default component.exports